import { useParams, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { DashboardContent } from '@starjack/widgets/dashboard';
import {
    getDashboardEnvConfig,
    type DashboardEnvSlug,
    DASHBOARD_ENV_SLUGS,
} from '@starjack/widgets/dashboard';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';

const Page: PageWithLayout = () => {
    const { dashboardEnv } = useParams<{ dashboardEnv: string }>();

    const slug = dashboardEnv as DashboardEnvSlug | undefined;
    if (!slug || !DASHBOARD_ENV_SLUGS.includes(slug)) {
        return <Navigate to='/404' replace />;
    }

    const config = getDashboardEnvConfig(slug, { appName: 'Starjack Admin' });

    return (
        <>
            <Helmet>
                <title>{config.title}</title>
            </Helmet>
            <DashboardContent environments={[config.environment]} />
        </>
    );
};

Page.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
Page.isProtected = true;
Page.permissions = [Permission.STATISTIC_NAV];

export default Page;
